//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchFunctions from './mixins/SearchFunctions';
import SearchFiltersTags from './components/SearchFiltersTags';

export default {
  name: "SearchApp",
  components: {
    SearchFiltersTags,
  },
  mixins: [SearchFunctions],
  data() {
    return { };
  },
  computed: { },
  methods: { },
  created() {
    this.initialize();
  },
};
